import { connect, type MapStateToProps, type MapDispatchToProps } from 'react-redux';
import { type StateProps, type DispatchProps, type OwnProps } from './types';
import { type State } from '../../state/types';
import OnDemandActivationView from './index';
import { getActivationStatus } from '../../state/activation/selectors';
import { updateOnDemandActivationModalState } from '../../state/ui/ondemand-activation/actions';
import { checkConfluenceActivationStatus } from '../../state/actions/activate-confluence';

const mapStateToProps: MapStateToProps<StateProps, OwnProps, State> = (state: State) => ({
	status: getActivationStatus(state),
});

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = (dispatch) => ({
	startStatusCheck: () => {
		dispatch(checkConfluenceActivationStatus());
	},
	changeModalState: (modalState) => {
		dispatch(
			updateOnDemandActivationModalState({
				modalState,
			}),
		);
	},
});

export default connect<StateProps, DispatchProps, OwnProps, State>(
	mapStateToProps,
	mapDispatchToProps,
)(OnDemandActivationView);
